import React, { useState, useContext, Fragment, useEffect } from "react";
import "../../../../../ui-styles/list/contactListAction.css";
import "../../../../../ui-styles/profile/HzntlProfile.css";
import DeleteConfirmModal from "../DeleteConfirmModal";
import { LangCtx, PayLoadCtx, SignalerCtx } from "../../../../../lib/context";
import { useHistory } from "react-router-dom";
import { DisableEnable, deleteUser } from "../../../../../actions/users";
import VerifyPopup from "../VerifyPopup";
import { getExperience } from "../../../../../lib/functions";
import Loading from "../../../../../components/loading";
import { toast } from "react-toastify";
import DisableEnableUser from "../DisableUser";
import { MdLockReset } from "react-icons/md";
import { Divider } from "@material-ui/core";
import ResetPwdPopup from "../../../../common/ResetPwdPopup";
import { resetpassword } from "../../../../../actions/users";
import Rating from '@material-ui/lab/Rating';


const DoctorListItem = (props) => {
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    const { signaler } = useContext(SignalerCtx);
    const history = useHistory();
    const { data, role } = props;
    const [openDelete, setOpenDelete] = useState(false);
    const [openPopup, setopenPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState(false);
    const [details, setdetails] = useState({});
    const [pswdPopup, setPswdPopup] = useState(false);

    const handleOpenPswd = () => {
        setPswdPopup(true);
    };
  
    const handleClosePswd = () => {
        setPswdPopup(false);
    };
    const handleVerify = () => {
        setopenPopup((prevState) => !prevState);
    };

    const handlePopup = () => {
        setopenPopup((prevState) => !prevState);
    };

    const handleOpen = () => {
        setOpenDelete((prevState) => !prevState);
    };

    const sendDeleteMessage = (user) => {
        const _txtCommand = {
            userId: payload && payload.userId ? payload.userId : "",
            messageType: "CMD",
            data: user,
        };
        signaler.deleteUserMessage(_txtCommand);
    };

    const handleDelete = () => {
        setLoading(true);
        deleteUser({ username: props.data.userId, consultRole: "doctor" })
            .then((res) => {
                if (res && res.status) {
                    props.reloadData();
                    toast.success(l.del_doc, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setLoading(false);
                    sendDeleteMessage(props.data.userId);
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.error, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                console.log("err ==== ", err);
            });
    };

    useEffect(() => {
        setdetails(data);
    }, [data]);

    const disableEnable = async () => {
        setLoading(true);
        DisableEnable({ userId: props.data.userId, isActive: !data.isActive })
            .then((res) => {
                setLoading(false);
                if (res && res.status) {
                    props.reloadData();
                    setActive(!active);
                    toast.success(res.data, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.error, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setLoading(false);
                console.log("err ==== ", err);
            });
    };

    return (
        <Fragment key={data.userId}>
            <li className="cntcListItem Md alignStart" key={data.userId}>
                {loading && <Loading />}
                <div className="cntcListAvtr Md">
                    {data?.profileImage?.url && data?.profileImage?.url !== "" ? (
                        <img src={data.profileImage.url} alt="avatar" />
                    ) : (
                        <div className="roundimg">{data.firstName.charAt(0)}</div>
                    )}
                </div>
                <div className="cntcListContent" onClick={() => props.handleSlide(details)}>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                        <span className="elslistTxtL">
                            {data.firstName ? data.firstName : ""}
                            {data.lastName ? ` ${data.lastName}` : ""}
                        </span>
                        <div>
                                <div
                                className="StatusChipRel"
                                    style={{
                                        backgroundColor:data.status ==="approved"?"#C8E6C9" :data.status === "rejected" ? "#FFCDD2" :"#FFF9C4" ,
                                    }}
                                >
                                    <span style={{ position: "relative" ,color:data.status ==="approved"? "#1B5E20" :data.status === "rejected" ? "#B71C1C" :"#6A5D00" }}> {data.status ? data.status : "pending"}</span>
                                    <div
                                    className="StatusChipAbs"
                                        style={{
                                            borderRight: data.status === "approved" ? "10px solid #C8E6C9" : data.status === "rejected" ? "10px solid #FFCDD2" : "10px solid #FFF9C4",
                                        }}
                                    ></div>
                                </div>
                        </div>
                        
                    </div>
                    <span className="elslistTxtM">
                        <Rating name="read-only" precision={0.1} value={data.ratings?.stars || 0}readOnly /></span>
                    <div className="rowBlock alignCenter">
                        
                        <span className="elslistTxtM elslistTxtN">{data.email ? `${data.email}, ` : ''}{data.countryCode ? `+${data.countryCode} ` : ''}{data.phone ? data.phone?.replaceAll('+91', '') : '--'}</span>
                        {/*verify && verify === true ?
                            <div className="actionItem noHover" tooltip="Verified">
                                <img src="/images/icons/verified.png" alt="icon" />
                            </div>
                            :
                            <div className="mrgLeft8">
                                <Button
                                    label={l.vfy}
                                    type='outLine'
                                    size='xs'

                                    onClick={(e) => {e.stopPropagation(); handlePopup(); }}
                                />
                        </div>*/}
                    </div>
                    <span className="elslistTxtM">{data.qualification ? data.qualification : ""}
                        {data.department ? data.department : ''}
                        {data.serviceStartDate ? `- ${getExperience(new Date(data.serviceStartDate))}` : ''}</span>
                    <span className="elslistTxtM">{data.speciality ? data.speciality : ''}</span>
                    {(role === "CA" || role === "SA") && <span className="elslistTxtM">{data.subdomain ? data.subdomain : '--'}</span>}

                </div>
                <div className="cntcListAction">
                <div  onClick={handleOpenPswd}
                     className="actionPswd" tooltip="Reset Password">
                     <MdLockReset style={{fontSize:'24px',color:'#23A4C4'}}/>
                    </div>
                    <Divider orientation="vertical" flexItem style={{alignSelf:'center', height:'30px' }}/>
                    {data.isActive === false ?
                        <div className="actionItem" onClick={()=>setActive(!active)} tooltip="Disable">
                            <img src="/images/icons/Block.png" alt="icon" />
                        </div>:
                        <div className="actionItem" onClick={()=>setActive(!active)} tooltip="Enable">
                            <img src="/images/icons/Doctor.png" alt="icon" className="invertPrimary" />
                        </div>
                    }
                    <div className="actionItem" tooltip="Edit" onClick={() => { (role === "CA" || role === "SA") ? history.push(`/admin-createusers?dId=${data.userId}`) : history.push(`/clinic-createusers?dId=${data.userId}`); }}>
                        <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary" />
                    </div>
                    <div className="actionItem" tooltip="Delete" onClick={handleOpen}>
                        <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                    </div>

                </div>
            </li>
            {active &&
                    <DisableEnableUser handleDelete={disableEnable} openDelete={active} closeDelete={()=>setActive(!active)} header={data.isActive === false?"Enable":"Disable"} />
            }
            {openDelete &&
                <DeleteConfirmModal handleDelete={handleDelete} openDelete={openDelete} closeDelete={handleOpen} data={data} header={l.doctor} />}
            {openPopup &&
                <VerifyPopup openVerify={openPopup} closePopup={handlePopup} handleVerify={handleVerify} phone={data.phone} />}
                 {pswdPopup && (
                        <ResetPwdPopup
                            open={pswdPopup}
                            onClose={handleClosePswd}
                            userData={data}
                            resetPassword={resetpassword}
                        />
                    )}


        </Fragment>
    );
};
export default React.memo(DoctorListItem);